'use client';

import { Box } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';

/**
 * Skip to main content link for keyboard navigation accessibility
 * Only visible when focused (tab key navigation)
 */
export function SkipToContent() {
  const theme = useTheme();

  return (
    <Box
      component="a"
      href="#main-content"
      sx={{
        position: 'absolute',
        left: '-9999px',
        zIndex: theme.zIndex.tooltip + 1000,
        padding: theme.spacing(2, 3),
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        textDecoration: 'none',
        borderRadius: 1,
        fontWeight: 600,
        fontSize: '1rem',
        boxShadow: theme.shadows[8],
        transition: theme.transitions.create(['left', 'box-shadow'], {
          duration: theme.transitions.duration.short,
        }),
        '&:focus': {
          left: theme.spacing(2),
          top: theme.spacing(2),
          outline: `3px solid ${alpha(theme.palette.primary.main, 0.5)}`,
          outlineOffset: '4px',
          boxShadow: theme.shadows[12],
        },
      }}
    >
      Skip to main content
    </Box>
  );
}
